<template>
	<section>
		<div
			tabindex="0"
			class="design"
			role="button"
			:aria-label="`Select image ${card.title}`"
			:class="[{ selected: selected }]"
			@click="$emit('selected')"
			@keydown.enter="$emit('selected')"
		>
			<div class="b360-fake-img-border"></div>
			<img
				:src="`${card.uri}`"
				class="b360-large-image-radio"
				:alt="card.title"
			/>
			<Radio
				:radioId="`select-card-${radioKey}`"
				radioGroupName="designGroup"
				:isChecked="selected"
				:radioDescription="`media group radio`"
			/>
		</div>
	</section>
</template>

<script>
import Radio from '@/components/global/Radio.vue';

export default {
	name: 'BBimageCard',
	components: {
		Radio,
	},
	props: {
		card: Object,
		radioKey: Number,
		selected: Boolean,
	},
};
</script>

<style lang="scss" scoped>
.b360-large-image-radio {
	max-width: 100%;
	display: block;
	border-radius: $b360-border-radius-base;
}

.design {
	margin-bottom: 20px;
	border-radius: $b360-border-radius-medium;
	position: relative;
	display: block;

	.b360-fake-img-border {
		box-shadow: inset 0 0 0 $b360-border-width-thin $border-color-light;
		display: flex;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		border-radius: $b360-border-radius-base;
	}

	.custom-radio {
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 1;
	}
}

.video {
	margin-bottom: 15px;

	.card-title {
		text-align: center;
		margin-bottom: 30px;
	}
}
.design {
	&:focus,
	&:active,
	&:hover {
		.b360-fake-img-border {
			box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;
		}

		.custom-radio {
			background-color: $brand-teal;
			box-shadow: inset 0 0 0 $b360-border-width-thin $brand-teal;
		}
	}
}
.selected {
	.b360-fake-img-border {
		box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;
	}

	.custom-radio {
		background-color: $brand-teal;
		box-shadow: inset 0 0 0 $b360-border-width-thin $brand-teal;
	}
}

.checkbox {
	height: 18px;
	width: 18px;
	border-radius: $b360-border-radius-medium;
	box-shadow: inset 0 0 0 $b360-border-width-thin $border-color-light;
	background-color: $white;
	position: absolute;
	top: 10px;
	right: 10px;
	z-index: 1;

	&:checked {
		box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;
		background-color: $brand-teal;
		color: $white;
		text-align: center;
		font-family: 'Font Awesome 5 Pro';

		&::after {
			display: inline-block;
			content: ' \2714';
		}
	}
}
</style>
